<template>
  <div>
    <EditSelection v-if="dataAvailable" />
    <JumpToPickNr v-if="dataAvailable" />
    <EditDrives v-if="dataAvailable" />
    <EditPicks v-if="dataAvailable" />
    <v-app-bar dense color="primary" max-height="48px" bottom>
      <v-toolbar-title>
        <template v-for="command in visibleCommands">
          <v-btn
            v-if="command.icon === null"
            :key="command.text"
            color="white"
            text
            rounded
            @click="command.functionToCall"
            :disabled="command.isDisabled"
          >
            {{ command.text }}
          </v-btn>
          <v-btn
            v-else
            :key="command.text"
            color="white"
            icon
            large
            @click="command.functionToCall"
            :disabled="command.isDisabled"
          >
            <v-icon v-text="command.icon"></v-icon>
          </v-btn>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu top offset-y v-if="menuCommandsVisible">
        <template v-slot:activator="{ on }">
          <v-btn color="white" icon v-on="on">
            <v-icon color="white">menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-for="menuItem in menuCommands">
            <v-list-item :key="menuItem.text">
              <v-list-item-title>
                <v-btn
                  text
                  rounded
                  @click="menuItem.functionToCall"
                  :disabled="menuItem.isDisabled"
                >
                  {{ menuItem.text }}
                </v-btn>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>
<script>
import {
  TOGGLE_SHOW_EDIT_SELECTION,
  TOGGLE_SHOW_JUMP_TO_PICK_NR,
  TOGGLE_SHOW_EDIT_DRIVES,
  TOGGLE_SHOW_EDIT_PICKS
} from "../../store/modules/showComponents/constants";
import {
  COPY_SELECTION,
  PASTE_SELECTION
} from "../../store/modules/clipboard/constants.js";
import { EDIT_SHAFT_JACQUARD } from "../../store/modules/uptData/constants";
import EditSelection from "./EditSelection";
import JumpToPickNr from "./JumpToPickNr";
import EditDrives from "./EditDrives";
import EditPicks from "./EditPicks";
import eventBus from "../utils/eventBus";
import { mapState } from "vuex";
import selection from "../utils/nonReactiveState/selection";
import clipboard from "../utils/nonReactiveState/clipboard";
const _ = require("lodash");

export default {
  name: "EditFooter",
  components: {
    EditSelection,
    JumpToPickNr,
    EditDrives,
    EditPicks
  },
  data: function() {
    return {
      editSelectionCommand: new footerCommand(
        "Edit selection",
        "border_color",
        this.openEditSelection
      ),
      copyCommand: new footerCommand("Copy", "content_copy", this.copy),
      pasteCommand: new footerCommand("Paste", "content_paste", this.paste),
      clearSelectionCommand: new footerCommand(
        "Clear selection",
        "layers_clear",
        this.clearSelection
      ),
      jumpToPickCommand: new footerCommand(
        "Jump to...",
        "$vuetify.icons.jumpToPick", // "low_priority"
        this.jumpToPick
      ),
      editDrivesCommand: new footerCommand(
        "Edit drives",
        "$vuetify.icons.editDrives",
        this.editDrivesDialog
      ),
      editPicksCommand: new footerCommand(
        "Edit picks",
        "$vuetify.icons.editPicks",
        this.editPicksDialog
      ),
      editShaftJacquardCommand: new footerCommand(
        "Shaft/Jacquard",
        "$vuetify.icons.editJacShaft",
        this.editShaftJacquard
      )
    };
  },

  mounted: function() {
    eventBus.$on("fileLoaded", this.disableCommandsIfUneditable);
    eventBus.$on("selectionUpdated", this.onSelectionChange);
  },

  beforeDestroy: function() {
    eventBus.$off("fileLoaded", this.disableCommandsIfUneditable);
    eventBus.$off("selectionUpdated", this.onSelectionChange);
  },

  computed: {
    ...mapState("uptData", [
      "editDrives",
      "editJacquard",
      "editShaft",
      "editColorControl",
      "editPicks",
      "editHooks",
      "canSelect",
      "canSave"
    ]),
    allCommands() {
      return [
        this.editSelectionCommand,
        this.copyCommand,
        this.pasteCommand,
        this.clearSelectionCommand,
        this.jumpToPickCommand,
        this.editPicksCommand,
        this.editDrivesCommand,
        this.editShaftJacquardCommand
      ];
    },
    numberOfVisibleCommands() {
      return this.$store.state.settings.numberOfVisibleFooterCommands;
    },
    visibleCommands() {
      if (
        _.isNil(this.allCommands) ||
        _.isEmpty(this.allCommands) ||
        _.isNil(this.numberOfVisibleCommands)
      ) {
        return [];
      } else if (this.allCommands.length <= this.numberOfVisibleCommands) {
        return this.allCommands;
      } else {
        return this.allCommands.slice(0, this.numberOfVisibleCommands);
      }
    },
    menuCommands() {
      if (
        _.isNil(this.allCommands) ||
        _.isEmpty(this.allCommands) ||
        _.isNil(this.numberOfVisibleCommands)
      ) {
        return [];
      } else if (this.allCommands.length <= this.numberOfVisibleCommands) {
        return [];
      } else {
        return this.allCommands.slice(this.numberOfVisibleCommands);
      }
    },
    menuCommandsVisible() {
      return !_.isNil(this.menuCommands) && !_.isEmpty(this.menuCommands);
    },
    dataAvailable() {
      return this.$store.state.uptData.dataAvailable;
    },
    clipboard() {
      return this.$store.state.selection.clipboard;
    }
  },

  methods: {
    clearSelection() {
      selection.resetSelection();
    },
    openEditSelection() {
      this.$store.dispatch(TOGGLE_SHOW_EDIT_SELECTION);
    },
    jumpToPick() {
      this.$store.dispatch(TOGGLE_SHOW_JUMP_TO_PICK_NR);
    },
    copy() {
      this.$store.dispatch(COPY_SELECTION);
    },
    paste() {
      this.$store.dispatch(PASTE_SELECTION);
    },
    editDrivesDialog() {
      this.$store.dispatch(TOGGLE_SHOW_EDIT_DRIVES);
    },
    editPicksDialog() {
      this.$store.dispatch(TOGGLE_SHOW_EDIT_PICKS);
    },
    editShaftJacquard() {
      this.$store.dispatch(EDIT_SHAFT_JACQUARD);
    },
    disableCommandsIfUneditable() {
      this.jumpToPickCommand.isDisabled = !this.dataAvailable;
      this.editDrivesCommand.isDisabled =
        !this.editDrives || !this.dataAvailable;
      this.editPicksCommand.isDisabled = !this.editPicks || !this.dataAvailable;
      this.editShaftJacquardCommand.isDisabled =
        !this.editHooks || !this.dataAvailable;
    },
    onSelectionChange() {
      if (selection.selectionList.length === 0) {
        this.editSelectionCommand.isDisabled = true;
        this.clearSelectionCommand.isDisabled = true;
        this.copyCommand.isDisabled = true;
        this.pasteCommand.isDisabled = true;
      } else {
        this.editSelectionCommand.isDisabled =
          !this.canSelect ||
          !this.$store.state.selection.isSelectionOneTypeOnly;
        this.clearSelectionCommand.isDisabled = false;
        this.copyCommand.isDisabled = !this.canSelect;
        this.pasteCommand.isDisabled =
          !this.canSelect || clipboard.isPasteDisabled();
      }
    }
  }
};

function footerCommand(
  text,
  icon = null,
  functionToCall = () => console.log("Not yet implemented"),
  isDisabled = true
) {
  this.text = text;
  this.icon = icon;
  this.functionToCall = functionToCall;
  this.isDisabled = isDisabled;
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
